import { captureException, withErrorBoundary } from '@sentry/react'
import { createFileRoute, notFound, redirect } from '@tanstack/react-router'

import { SentryErrorPage } from '@/pages/error/SentryErrorPage'
import { AdminPromotionPlacementsPage } from '@/pages/promotions/AdminPromotionPlacementsPage'
import { regionsQuery } from '@/state/regions/regions'

export const Route = createFileRoute('/promotions/$initiativeId/placements')({
  component: withErrorBoundary(AdminPromotionPlacementsPage, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  beforeLoad: ({ context }) => {
    if (!context.auth.super_admin) {
      if (!context.auth.regionId) {
        throw notFound()
      }

      throw redirect({
        from: Route.fullPath,
        to: '/promotions/$initiativeId/$regionId',
        params: { regionId: context.auth.regionId },
      })
    }
  },
  loader: async ({ context }) => {
    await context.queryClient.prefetchQuery(regionsQuery())
  },
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
